module.exports = __webpack_public_path__ + "static/media/onboarding-4_2x.60d9c995.png";